<header class="dialog-header">
    <h3 mat-dialog-title>Bautagebuch</h3>
    <fa-icon class="close-button" icon="times" size="2x" (click)="dialogRef.close()"></fa-icon>
</header>
<div class="flex flex-col">
    <div class="flex flex-wrap items-center" *ngIf="(commissionPath$ | async).length">
        <ng-container *ngFor="let c of commissionPath$ | async; let first = first">
            <fa-icon icon="chevron-right" *ngIf="!first"></fa-icon>
            <button mat-button class="not_selected_commission" (click)="selectCommissionId(c.Id)" *ngIf="c.Id !== (selectedCommissionId$ | async); else selectes">
                {{c.ParentId ? 'Zum Teilprojekt: ' : 'Zum Hauptprojekt: '}}
                {{c.GetDisplayName()}}
            </button>
            <ng-template #selectes>
                <button mat-button class="selected_commission">
                    <span style="font-weight: bold;">Aktiv: </span>
                    <span>{{c.GetDisplayName()}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
    <ng-container *ngIf="(Diary$ | async) as diary">
        <div class="app_file_count" *ngIf="diary.AppFileCount != diary.AppUploadedFileCount">
            {{ diary.AppUploadedFileCount }} / {{ diary.AppFileCount }} Offline Dateien synchronisiert
        </div>
    </ng-container>
</div>
<mat-tab-group mat-align-tabs="center" (selectedTabChange)="onSelectedTabChange()">
    <mat-tab [label]="'Haupt' + (cls.getSingle$('Commission') | async).toLowerCase()">
        <app-small-commission-overview class="scrollable dialog-content block" [commissionId]="commissionOrParentId$ | async"></app-small-commission-overview>
    </mat-tab>
    <mat-tab #btgbTab label="Tagebucheintrag">
        <div class="scrollable dialog-content" *ngIf="Diary$ | async as diary; else loading">
            <div class="header">
                <b>{{ (commissionOrParent$ | async)?.DisplayName }}</b><br />
                Datum: {{ diary.Date | date }} {{ (IsToday$ | async) ? '(heute)' : '' }}<br />
                Status: {{ GetStatusName(diary) }}
                <ng-container *ngIf="showAuthor$ | async">
                    <ng-container *ngIf="authorName$ | async as author"><br /> Bearbeiter: {{author}}</ng-container>
                </ng-container>
                <mat-error *ngIf="(commissionOrParent$ | async)?.Deleted">{{cls.getSingle$('Commission') | async}} wurde gelöscht{{ diary.Id ? '' : ', es kann kein Bautagebuch angelegt werden.' }}</mat-error>
            </div>
            <mat-horizontal-stepper class="stepper-wrapper" [linear]="false" #matStepper (selectionChange)="onStepSelectionChange($event)" *ngIf="!(commissionOrParent$ | async)?.Deleted || diary.Id">
                <mat-step *ngFor="let page of pages$ | async; let i = index" #step>
                    <ng-container *ngTemplateOutlet="page; context: { diary: diary, active: step === matStepper.selected }"></ng-container>
                    <ng-template matStepLabel>S. {{ i + 1 }}</ng-template>
                    <mat-divider class="bottom-divider"></mat-divider>
                </mat-step>
                <ng-template matStepperIcon="edit">
                    <fa-icon icon="pencil-alt"></fa-icon>
                </ng-template>
                <!-- <ng-template matStepperIcon="number">
                    <fa-icon icon="pencil-alt"></fa-icon>
                </ng-template> -->
                <ng-template matStepperIcon="done">
                    <fa-icon icon="check"></fa-icon>
                </ng-template>
                <ng-template matStepperIcon="error">
                    <fa-icon icon="exclamation-triangle"></fa-icon>
                </ng-template>
            </mat-horizontal-stepper>
        </div>
    </mat-tab>
</mat-tab-group>
<mat-dialog-actions class="footer">
    <ng-container [ngSwitch]="SelectedIndex" *ngIf="btgbTab.isActive">
        <ng-container *ngSwitchCase="(pages$ | async | length) - 1">
            <ng-container *ngIf="PartnerTypeId$ | async as partnertypeId">
                <div class="cancel-button-wrapper">
                    <button app-button Inverted mat-dialog-close matTooltip="Abbrechen">Abbrechen</button>
                </div>
                <button
                    [Disabled]="SomeRequiredTaskPending$ | async"
                    *ngIf="partnertypeId !== PartnerTypeKagetec"
                    app-button
                    (click)="Save(null, true)"
                    mat-dialog-close
                    matTooltip="Speichern und schließen"
                    [IsLoading]="LS.IsLoading$ | async"
                >
                    Speichern
                </button>
                <button
                    [Disabled]="SomeRequiredTaskPending$ | async"
                    *ngIf="partnertypeId === PartnerTypeKagetec"
                    app-button
                    (click)="Save(null, true)"
                    mat-dialog-close="open-time-tracking-kagetec"
                    matTooltip="Jetzt Zeiten erfassen"
                    [IsLoading]="LS.IsLoading$ | async"
                >
                    Jetzt Zeiten erfassen
                </button>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <div class="cancel-button-wrapper">
                <button app-button Inverted mat-dialog-close matTooltip="Abbrechen">Abbrechen</button>
            </div>
            <button app-button matTooltip="Speichern und weiter" (click)="MatStepper?.next()" [IsLoading]="LS.IsLoading$ | async" [Disabled]="SelectedIndex === 0 && (SaveButtonDisabled$ | async)">Speichern und weiter</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!btgbTab.isActive">
        <button app-button Inverted mat-dialog-close Color="cancel">Abbrechen</button>
    </ng-container>
</mat-dialog-actions>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>

<ng-template #page1 let-diary="diary">
    <ng-container *ngIf="PartnerTypeId$ | async as partnertype">
        <div *ngIf="PartnerTypeKagetec === partnertype">
            <h3>Baustellen Inspektion</h3>
            <div class="lmra-button-wrapper">
                <!--                <a href="/assets/downloads/kagetec/lmra.pdf" target="_blank" app-button [Lighter]="true" class="open-button">öffnen</a>-->
                <div>
                    <button app-button [Lighter]="true" (click)="onOpenInspection()" [IsLoading]="LS.IsLoading$ | async">öffnen</button>
                    <mat-label *ngIf="HasInspection$ | async">Baustelleninspektion durchgeführt <fa-icon icon="check"></fa-icon></mat-label>
                    <mat-label *ngIf="!(HasInspection$ | async)">Baustelleninspektionsformular öffnen</mat-label>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container [ngTemplateOutlet]="nameForm"></ng-container>
    <ng-container [ngTemplateOutlet]="weatherForm"></ng-container>
    <app-dave-list-card
        Headline="Tägliche Aufgaben"
        [Data]="TaskTableData$ | async"
        [HasSuffixButton]="true"
        [DisplayedCollums]="['Name', 'stateName']"
        [TableHeaderCollumsMap]="{ time: 'Uhrzeit', Name: 'Name', stateName: 'Status' }"
        [Clickable]="true"
        [DisableListEntryByButton]="true"
        DefaultSortActive="time"
        (EntryClicked$)="$event.entry.suffixButton.disabled === false ? $event.entry.suffixButton.onClick($event.entry) : null"
    >
    </app-dave-list-card>
</ng-template>

<ng-template #page2 let-diary="diary" let-active="active">
    <app-textfield *ngIf="showTitle$ | async" Key="Titel" [Value]="Form.controls.Title"></app-textfield>
    <ng-container *ngIf="showWeatherOnPage2$ | async" [ngTemplateOutlet]="nameForm"></ng-container>
    <ng-container *ngIf="showWeatherOnPage2$ | async" [ngTemplateOutlet]="weatherForm"></ng-container>
    <div *ngIf="showExecutingCompany$ | async" class="flex gap-4 items-center">
        <app-textfield class="grow" Key="Ausführende Firma" [Value]="Form.controls.ExecutingCompany"></app-textfield>
        <button (click)="onAddAssignedPersons()" app-button [disabled]="(assignedPersons$ | async)?.length === 0">Projektbeteiligte hinzufügen</button>
    </div>
    <div class="flex-row">
        <h3>{{ leistungsergebnisseLabel$ | async }}</h3>
        <mat-slide-toggle [(ngModel)]="LeistungsergebnisseUseTemplateMode">Vorlagen</mat-slide-toggle>
    </div>
    <app-text-area-templates *ngIf="LeistungsergebnisseUseTemplateMode" [formControl]="Form.controls.LeistungsergebnisseTemplate"></app-text-area-templates>
    <app-textarea *ngIf="!LeistungsergebnisseUseTemplateMode" MaxHeight="200px" [Key]="leistungsergebnisseLabel$ | async" [Value]="Form.controls.Leistungsergebnisse"></app-textarea>
    <app-textarea *ngIf="isLuksch$ | async" MaxHeight="200px" Key="Bedenken" [Value]="Form.controls.Bedenken"></app-textarea>
    <app-textarea *ngIf="showBesondereVorkommnisseForm$ | async" MaxHeight="200px" Key="Besondere Vorkommnisse" [Value]="Form.controls.BesondereVorkommnisse"></app-textarea>
    <app-textarea *ngIf="showLeistungsaenderungenForm$ | async" MaxHeight="200px" Key="Leistungsänderungen" [Value]="Form.controls.Leistungsaenderungen"></app-textarea>
    <ng-container *ngIf="isLuksch$ | async">
        <h3>Materialeingabe</h3>
        <app-construction-diary-material-device-list [forms]="Form.controls.MaterialDevices"></app-construction-diary-material-device-list>
    </ng-container>
    <div class="headline">
        <h3><fa-icon icon="paperclip"></fa-icon> Anhänge</h3>
        <span class="spacer"></span>
        <mat-slide-toggle [(ngModel)]="DMSNotMinimalistic" [disabled]="!(Folder$ | async)">DMS</mat-slide-toggle>
        <button style="margin-left: auto" app-round-button (click)="OpenFileUpload(diary.CommissionId)" matTooltip="Dateien hinzufügen" [Disabled]="(commissionOrParent$ | async)?.Deleted">
            <app-double-icon [Icon]="DMSMeta.Icon" Icon2="upload"></app-double-icon>
        </button>
    </div>
    <app-dropzone *ngIf="fileUploadParams$ | async as fileUploadParams" clearOnSuccess autoProcess style="min-height: 160px" [fileUploadParams]="fileUploadParams"></app-dropzone>
<!--  lasy render because of wrong width on initial render  -->
    <ng-container *ngIf="active && !(commissionOrParent$ | async)?.Deleted">
        <app-file-explorer
            [FileUploadConfig]="{ ConstructionDiaryId: folder.Type === FolderTypes.construction_diary ? folder.EntityId : null, FolderId: folder.Id }"
            [FileUploadButton]="true"
            (FileClicked)="CloseSideDialog()"
            (FileUploadClicked)="CloseSideDialog()"
            [Minimalistic]="!DMSNotMinimalistic"
            style="height: 20rem"
            [contentHeight]="'16rem'"
            [expandable]="false"
            *ngIf="Folder$ | async as folder; else loading"
            [SelectedFolderId]="folder.Id"
            [DisableRoutingParams]="true"
        ></app-file-explorer>
    </ng-container>
    <mat-error *ngIf="(commissionOrParent$ | async)?.Deleted">
        Dateien gelöschter Aufträge können nicht mehr angezeigt werden.
    </mat-error>
    <ng-container *ngIf="showPlans$ | async">
        <h3>Pläne</h3>
        <app-construction-diary-plans (screenshotTaken)="onScreenshotTaken($event)" [commissionId]="commissionOrParentId$ | async" [mapMarker]="Form.controls.MapMarker.value" (mapMarkerChange)="onMapMarkerChange($event)" [defaultMarker]="defaultMarker"></app-construction-diary-plans>
    </ng-container>
</ng-template>

<ng-template #page3 let-diary="diary">
    <ng-container *ngIf="EventsErschwerniss$ | async as events">
        <app-dave-list-card
            *ngFor="let eventGroup of events"
            Headline="{{ eventGroup.type }}"
            [HeaderIcon]="eventGroup.icon | icon"
            [Data]="eventGroup.events"
            [DisplayedCollums]="['Name', 'Description', 'EventDate', 'FileCount']"
            [TableHeaderCollumsMap]="{ Name: 'Name', Description: 'Beschreibung', EventDate: 'Datum', FileCount: 'Anhänge' }"
            [CustomCellTemplates]="{ EventDate: dateColumn }"
            [DefaultSortActive]="'EventDate'"
            [Clickable]="true"
            (EntryClicked$)="OpenEditEventDialog($event.entry)"
            style="margin-bottom: 1rem; max-height: 50vh"
            [IsExpandable]="events.length > 1"
            [Expanded]="false"
        >
            <button headerButton app-round-button matTooltip="{{ eventGroup.type }} hinzufügen" [IsLoading]="!(Diary$ | async)?.Id" (click)="AddEvent(eventGroup.typeId, diary, eventGroup.type)">
                <fa-icon icon="plus"></fa-icon></button
        ></app-dave-list-card>
    </ng-container>
</ng-template>
<ng-template #dateColumn let-data="data"> {{ data.EventDate | date }}&nbsp; </ng-template>
<ng-template #page4 let-diary="diary">
    <ng-container *ngIf="EventsZusatz$ | async as events">
        <app-dave-list-card
            *ngFor="let eventGroup of events"
            Headline="{{ eventGroup.type }}"
            [HeaderIcon]="eventGroup.icon | icon"
            [Data]="eventGroup.events"
            [DisplayedCollums]="['Name', 'Description', 'EventDate', 'FileCount']"
            [TableHeaderCollumsMap]="{ Name: 'Name', Description: 'Beschreibung', EventDate: 'Datum', FileCount: 'Anhänge' }"
            [CustomCellTemplates]="{ EventDate: dateColumn }"
            [DefaultSortActive]="'EventDate'"
            [Clickable]="true"
            (EntryClicked$)="OpenEditEventDialog($event.entry)"
            style="margin-bottom: 1rem; max-height: 50vh"
            [IsExpandable]="events.length > 1"
            [Expanded]="false"
        >
            <button headerButton app-round-button matTooltip="{{ eventGroup.type }} hinzufügen" (click)="AddEvent(eventGroup.typeId, diary, eventGroup.type)">
                <fa-icon icon="plus"></fa-icon></button
        ></app-dave-list-card>
    </ng-container>
</ng-template>
<ng-template #timeTrackingPage>
    <div class="flex flex-wrap gap-4">
        <div class="basis-md flex flex-col">
            <app-travel-zone-select [formControl]="Form.controls.TravelZone" [requiredId]="(Diary$ | async)?.TravelZoneId"></app-travel-zone-select>
            <mat-checkbox class="ml-2 m-1" [formControl]="Form.controls.ToolFee">Werkzeugpauschale</mat-checkbox>
            <mat-checkbox class="ml-2 m-1" [formControl]="Form.controls.SmallAndSealingMaterial">Klein und Dichtmaterial</mat-checkbox>
            <mat-checkbox class="ml-2 m-1" [formControl]="Form.controls.WorkCompleted">Arbeiten abgeschlossen <app-hint-icon hint="setzt nach dem Speichern oder Bericht erstellen auch den Status des Projektes auf &quot;Abgeschlossen&quot;"></app-hint-icon></mat-checkbox>
        </div>
        <div class="basis-md">
            <h3>Zeiten</h3>
            <app-construction-diary-time-tracking [day]="diaryDate$ | async" [commissionId]="commissionOrParentId$ | async"></app-construction-diary-time-tracking>
        </div>
        <div class="basis-md flex flex-col">
            <h3>Bericht</h3>
            <mat-action-list style="margin-right: auto;">
                <ng-container *ngIf="diaryGeneratedDocumentId$ | async; else noGenDocItem">
                    <ng-container *ngIf="generatedDocumentForDiary$ | async as genDoc; else loading">
                        <button mat-list-item *ngIf="genDoc.found; else notFound" (click)="openGeneratedDocumentDialog(genDoc.found.Id)" matTooltip="Bericht öffnen">
                            <fa-icon mat-list-icon [icon]="GeneratedDocumentsPageMeta.Icon"></fa-icon>
                            <div mat-line>{{ genDoc.found.Name }}</div>
                            <div mat-line>{{ genDoc.found.CreatedAt | date }}</div>
                            <!--                <a mat-icon-button *ngIf="genDoc.DocumentIdFromPdf as documentId" [routerLink]="['/', DMSMeta.Path]" [queryParams]="{ documentId }"><fa-icon [icon]="DMSMeta.Icon"></fa-icon></a>-->
                            <div class="theme-override ml-8" [class]="DMSMeta.Theme" *ngIf="genDoc.found.DocumentIdFromPdf as documentId">
                                <button app-round-button (click)="openFileDialog(documentId); $event.preventDefault()" matTooltip="PDF Datei anzeigen"><fa-icon [icon]="'file-pdf'"></fa-icon></button>
                            </div>
                        </button>
                        <ng-template #notFound>
                            <p>Bericht wurde gelöscht</p>
                        </ng-template>
                    </ng-container>
                </ng-container>
                <ng-template #noGenDocItem>
                    <mat-list-item>Kein Bericht erstellt</mat-list-item>
                </ng-template>
            </mat-action-list>
            <div class="theme-override my-4" [class]="GeneratedDocumentsPageMeta.Theme">
                <button app-button (click)="createExport()"><fa-icon class="icon" [icon]="GeneratedDocumentsPageMeta.Icon"></fa-icon> Bericht erstellen</button>
            </div>
        </div>
        <div class="signature-wrapper flex flex-col items-center flex-shrink-0" *ngIf="SignatureImage$ | async as signature">
          <h3>Unterschrift</h3>
          <div class="signature-container">
            <img [src]="signature" />
          </div>
        </div>
    </div>
</ng-template>
<ng-template #weatherForm>
    <h3>Wetterverhältnisse</h3>
    <div class="weather-wrapper">
        <app-textarea Key="Wettersituation (sonnig, wolkig ...)" [Value]="Form.controls.Weather"></app-textarea>
        <app-numberfield Key="Temp" [FormControl]="Form.controls.Temperature"><div textfieldSuffix>°C</div></app-numberfield>
    </div>
</ng-template>

<ng-template #nameForm>
    <h3>Name</h3>
        <app-textarea Key="Name" [Value]="Form.controls.Name"></app-textarea>
        <app-textarea Key="Nummer" [Value]="Form.controls.ConstructionDiaryNumber"></app-textarea>
        <mat-slide-toggle  class="hover-form" (toggleChange)="Form.controls.AutomaticConstructionDiaryNumber.setValue(!Form.controls.AutomaticConstructionDiaryNumber.value)" [checked]="Form.controls.AutomaticConstructionDiaryNumber.value">
            Nummer automatisch vergeben
        </mat-slide-toggle>
</ng-template>
